const config = require("../config")
const url = config.base_dev_url + "v3/farm/"

module.exports = {
    phenologyInitOrConfirmStatus: {
        url: url + "phenologyInitOrConfirmStatus",
        type: "get",
    },
    initFarmData: {
        url: url + "initFarmData",
        type: "post",
    },
    confirmReproductivePhenology: {
        url: url + "confirmReproductivePhenology",
        type: "post",
    },
    // 获取主题下全部农场的品种列表与物候期选项
    farmTypeIdAndPhenologyList: {
        url: url + "farmTypeIdAndPhenologyList",
        type: "get",
    }
}